export const MARKETS_SET_DATA_LOADING_STATE = 'MARKETS_SET_DATA_LOADING_STATE';
export const MARKETS_SET_REQUEST_LOADING_STATE = 'MARKETS_SET_REQUEST_LOADING_STATE';
export const MARKETS_SET_ERROR = 'MARKETS_SET_ERROR';
export const MARKETS_RESET_ERROR = 'MARKETS_RESET_ERROR';
export const MARKETS_SET_MARKET_DATA = 'MARKETS_SET_MARKET_DATA';
export const MARKETS_SET_CLIENT_LIST = 'MARKETS_SET_CLIENT_LIST';
